import { Page } from '../../../core/entities/page/page';
import { gql } from 'apollo-angular';
import { Article } from '../../shared/entities/article/article';

export const ARTICLES_QUERY = gql`
query articlesQuery($pageNumber: Int, $pageSize: Int, $sortProperty: String, $sortDirection: String, $articleNumber: String, $articleName: String)
{
  articles: getArticlesPaged(
    filter: {
      sortRequest: { sortProperties: [$sortProperty], sortDirection: $sortDirection },
      pagination: { number: $pageNumber, size: $pageSize,  sortProperty: $sortProperty, sortDirection: $sortDirection},
      number: $articleNumber, name: $articleName
    }
    ) {
      totalPages
      totalElements
      number
      size
      content{
          id
	        name
          number
      }
  }
}
`;

export interface ArticlesQueryResponse {
  articles: Page<Article>;
  loading: boolean;
}
